import React, { useEffect } from 'react';
import Alert from '@mui/material/Alert';

/**
 * Generic notification component that can display errors, successes,
 * warnings or informational messages.
 * Props:
 *   error?: any          // used when severity === 'error'
 *   message?: string     // plain text message for other severities
 *   severity?: 'error'|'success'|'info'|'warning'  (default: 'error')
 *   duration?: number    // milliseconds until auto-clear (default: 15000)
 *   onClear?: ()=>void
 */
function formatError(errorObject) {
  if (!errorObject) return '';
  if (typeof errorObject === 'string' && errorObject.length) return errorObject;
  const msg = errorObject.message || '';
  const jsonMatch = msg.match(/\{.*\}$/);
  if (jsonMatch) {
    try {
      const parsed = JSON.parse(jsonMatch[0]);
      if (parsed.error) return parsed.error;
    } catch (e) {
      // ignore parse failure
    }
  }
  return msg || '';
}

export default function NotificationAlert({
  error,
  message = '',
  severity = 'error',
  duration = 15000,
  onClear,
}) {
  let display;
  if (severity === 'error') {
    display = formatError(error) || '';
  } else {
    display = message || '';
  }

  useEffect(() => {
    if (!display) return;
    const id = setTimeout(() => {
      onClear && onClear();
    }, duration);
    return () => clearTimeout(id);
  }, [display, duration, onClear]);

  if (!display) return null;
  return (
    <Alert severity={severity} sx={{ mb: 2 }}>
      {display}
    </Alert>
  );
}
